module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_desktop-8ad7e52ad6afabe72a8a971ac4660851.jpg";